import { curry, type PlatformEvent } from 'lib/util'

/**
 * Returns the y-axis unit labels for the cavitation intensity chart.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 * @returns the label's text
 */
const formatCavitationIntensityYLabel = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent<{ label: number }>,
): string => {
  const label = event.detail.label as number
  const { data } = component[G.STATE]
  const max = Math.max(...(data || []).map(p => p.apm))
  const min = Math.min(...(data || []).map(p => p.apm))
  const range = max - min
  let yPrecision = Math.max(0, Math.ceil(-Math.log10(range / 10)));
  if (!Number.isFinite(yPrecision)) {
    yPrecision = 0;
  }
  return label.toFixed(yPrecision)
}

export default curry(formatCavitationIntensityYLabel)
